<template>
  <form class="search__search-form" ref="form" :action="page">
    <transition name="fade">
      <div class="search__search-form-inner" v-show="!advancedExpanded">
        <input
          type="text"
          name="q"
          ref="input"
          placeholder="Search"
          class="search__search-form-input"
          required
        />
        <button
          type="submit"
          ref="submit"
          class="search__search-form-submit"
          aria-label="Submit search"
        >
          <slot>
            <img src="/images/Search.svg" alt="" />
          </slot>
        </button>
      </div>
    </transition>
  </form>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  props: {
    page: {
      type: String,
      default: '/search-results',
    },
  },
  data() {
    return {
      advancedExpanded: false,
    }
  },
  methods: {
    toggleExpanded(expanded) {
      this.advancedExpanded = expanded
    },
  },
  mounted() {
    // listen and hide if the advanced search is displayed
    eventBus.$on('search:advanced', this.toggleExpanded)
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-in;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
